import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {Templates} from '../../../models/templates.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';
import {EditTemplateComponent} from '../edit-template/edit-template.component';

@Component({
  selector: 'app-templates-table',
  templateUrl: './templates-table.component.html',
  styleUrls: ['./templates-table.component.scss']
})
export class TemplatesTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['description', 'category.description', 'subject', 'edit'];

  @Input()
  templates!: Templates[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadTemplates: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateTemplateStatus: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  deleteTemplate: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadTemplates.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadTemplates.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  editTemplate(value: Templates): void {
    const dialogRef = this.dialog.open(EditTemplateComponent, {data: value, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadTemplates.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateTemplate(template: Templates, deleteTemplate: boolean): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${deleteTemplate ? 'Delete' : (template.status === 'ACTIVE' ? 'Disable' : 'Enable')} Template`,
            text: `Are you sure you want to ${deleteTemplate ? 'delete' : (template.status === 'ACTIVE' ? 'deactivate' : 'activate')} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        if (deleteTemplate) {
          this.deleteTemplate.emit(template.id);
        }
        else {
          this.updateTemplateStatus.emit(template.id);
        }
      }
      dialogRef.close();
    });
  }

}
